import { forwardRef, useImperativeHandle, useRef } from 'react';
import { FormControl, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';

const BaseInputValidation = forwardRef(function BaseInputValidation(
	{
		control,
		name,
		label,
		errors,
		config = {
			type: '',
			styles: {},
			classes: '',
			disabled: false,
			helperText: '',
			disableAutofill: false,
		},
		...props
	},
	externalRef
) {
	const inputRef = useRef(); // internal ref for the MUI input

	// Expose the DOM node to the parent via ref
	useImperativeHandle(externalRef, () => inputRef.current);

	const { styles, classes, type, disabled, helperText, disableAutofill } = config;

	return (
		<FormControl sx={styles} className={classes || 'w-full'}>
			<Controller
				control={control}
				name={name}
				render={({ field: { onChange, onBlur, value, ref } }) => (
					<TextField
						onBlur={onBlur}
						onChange={onChange}
						value={value || ''}
						inputRef={(el) => {
							ref(el);
							inputRef.current = el;
						}}
						label={label}
						size='small'
						type={type || 'text'}
						error={!!errors[name]?.message}
						helperText={errors[name]?.message || helperText}
						placeholder={props.placeholder || ''}
						disabled={disabled}
						className='input-default'
						inputProps={{
							autoComplete: disableAutofill ? 'new-password' : 'on',
							...(disableAutofill && {
								name: `field-${Math.random().toString(36).substring(2)}`,
								'data-lpignore': 'true',
								'data-1p-ignore': 'true',
								'data-form-type': 'other',
								suppressContentEditableWarning: true,
								readOnly: !props.autoFocus,
								onFocus: (e) => {
									if (!props.autoFocus) e.target.removeAttribute('readonly');
								},
							}),
						}}
						{...props}
					/>
				)}
			/>
		</FormControl>
	);
});

export default BaseInputValidation;
